import { MediaQueryContext } from 'libs/contexts';
import { emptyStyles } from 'libs/utils';
import { CSSProperties, useContext } from 'react';

export type ContainerProps = {
  children: React.ReactNode;
  styles?: string;
  style?: CSSProperties;
};

export default function Container(props: ContainerProps) {
  const { isMobile } = useContext(MediaQueryContext);
  return isMobile ? <ContainerH5 {...props} /> : <ContainerPC {...props} />;
}

function ContainerPC({ children, styles = emptyStyles, style }: ContainerProps) {
  return (
    <div className="container clearfix" style={style}>
      {children}
      <style jsx>{`
        .container {
          width: 1200px;
          height: auto;
          margin: 0 auto;
        }
      `}</style>
      <style jsx>{styles}</style>
    </div>
  );
}

function ContainerH5({ children, styles = emptyStyles }: ContainerProps) {
  const { phoneBreakpoint } = useContext(MediaQueryContext);

  return (
    <div className="container">
      {children}
      <style jsx>{`
        .container {
          width: 1200px;
          height: auto;
          margin: 0 auto;
        }
      `}</style>
      <style jsx>{`
        @media ${phoneBreakpoint} {
          .container {
            width: 100%;
          }
        }
      `}</style>
      <style jsx>{styles}</style>
    </div>
  );
}
